const getPosition = () =>  {
  return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {timeout: 1000})
  })
}
const isMobileDevice = () => {
  const ua = navigator.userAgent.toLowerCase()
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mac|/i.test(ua)
  return !!(isMobile && navigator.maxTouchPoints > 1)
}
export async function getGps() {
  let lat = 0; // latitude
  let lon = 0; // longitude
  const position = await getPosition().catch(() => {})
  if (isMobileDevice() && position) {
    lat = (position.coords.latitude * 1000000).toFixed(0) || 0
    lon = (position.coords.longitude * 1000000).toFixed(0) || 0
  }
  return { lat, lon }
}
